<template>
  <div>
    <p v-if="attachment.comment" class="lead pre-line">{{ attachment.comment }}</p>
    <Details v-if="attachment.object_type" :attachment="attachment" label="Triggered by"></Details>
    <Notifications v-if="attachment.notifications_sent"
                   :notifications="attachment.notifications_sent.notifications"
                   :inbasketMessages="attachment.notifications_sent.inbasketMessages">
    </Notifications>
  </div>
</template>

<script>
  import Details from './Details.vue';
  import Notifications from "./Notifications.vue";

  export default {
    components: {
      Details,
      Notifications,
    },
    props: {
      attachment: {
        type: Object,
        default: function () {
          return {};
        }
      },
    },
    computed: {
      inbasketMessages() {
        return this.incident.attachments
          .filter(attachment => attachment.object_type === "EpicInbasketMessage")
          .map(attachment => attachment.details);
      }
    }
  }
</script>

<style scoped>
  .pre-line {
    white-space: pre-line;
  }
</style>